/* eslint-disable eqeqeq */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import i18n from "../../i18n"
import { EditInvoiceReportTable } from "./EditInvoiceReportTable"
import { InfoBar } from "./Info"
import Accordion from '../Accordion/StyledAccordion';
import { Logs } from "../../services/API/Logs"
import Datalist, { ListColumn } from "../Datalist/Datalist"
import { /*DeleteModalState, HandleDeleteModal,*/ ActionModalState, ConfirmButtonActions, HandleActionModal, InternalInvoiceReport, InternalKeysForEIRT,Reportedperiod,/*, InvoicesWithCsrdAndGroupId*/ 

/*ReportedPeriodReportType*/} from "./editTypes"
import { Contract } from '../../services/API/Contracts';
import { Customer } from "../../services/API/Customer"
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { t } from "i18next";
import { Button, Spinner } from "react-bootstrap";
import { IsUserSinfra } from "../../lib/utils";
import { Department } from "../../services/API/Departments";
import { ActionModal } from "./ActionModal";
import React from "react";
interface StandardReportViewProps{
    data:InternalInvoiceReport;
    invoiceReportOnChange:(e:React.ChangeEvent<HTMLTextAreaElement> | number,key:keyof Pick<InternalInvoiceReport,'departmentId' | 'comment'>,item?:InternalInvoiceReport)=>void;
    callBack:<T extends object>(item:T,index?:number,key?:keyof T)=>void;
    reportType:InternalKeysForEIRT;
    addRow:()=>void;
    deleteRow:(id:number)=>void;
    handleDeleteModal:HandleActionModal;
    deleteModal:ActionModalState;
    copyRow:<T extends object>(item:T,index:number) => void;
    contract:Contract[];
    customers:Customer[];
    submit:() =>void;
    submitActive:boolean;
    editHistory:any;
    departments?:Department[];
    department?:Department;
    logs?:Logs[];
    search:(searchString:string) => Promise<void>;
    searchCache:{searchString:string,active:boolean,searchResult:{rowsFound:number,data?:any}};
    searchLoading:boolean;
    reportedPeriods:{[key:string]:Reportedperiod[]};
    movedItems:(period:string,item:any,index:number,reportType:'InvoiceReport' | 'NullReport',action:ConfirmButtonActions,supplierOrgId:string,batchId?:string,departmentId?:number)=>void;
    noRowsLeft:boolean;
    resetReport:(historyId:number) => void;
    editModeActive:boolean;
}

export const StandardInvoiceReportView = ({searchLoading,searchCache,search,data,invoiceReportOnChange,callBack,reportType,addRow,deleteRow,handleDeleteModal,deleteModal,copyRow,contract,customers,submit,submitActive,editHistory,departments,department,logs,reportedPeriods,movedItems,noRowsLeft,resetReport,editModeActive}:StandardReportViewProps) => {
  const [internalSearchString,setInternalSearchString] = React.useState('')
  const logColumns:ListColumn<Logs>[] = [
        {
            fieldName: "timeReported",
            isActive: true,
            key: "timeReported",
            minWidth: '',
            maxWidth: 150,
            sorting: true,
            name: 'timeReported',
            onRender:(item,col) => {
              return <p style={{width:'50px',margin:'0'}}>{new Date(item.timeReported).toLocaleDateString()}</p>                     
            }
            
          },
          {
            fieldName: "logLevel",
            isActive: true,
            key: "logLevel",
            minWidth: '',
            maxWidth: 100,
            //width:'35px !important',
            sorting: true,
            name: 'logLevel',
            
          },
          {
            fieldName: "logText",
            isActive: true,
            key: "logText",
            minWidth: '',
            //maxWidth: undefined,
            //width:'400px !important',
            sorting: true,
            name:'logText',
            onRender:(item,col) => {
              return <p style={{margin:'0'}}>{item.logText}</p>
            }
            
          }
        
    ]
    return(
      <>
           {
            deleteModal.show &&
            ActionModal(deleteModal,addRow,deleteRow,copyRow,handleDeleteModal,invoiceReportOnChange,submit,resetReport)
          }
           <InfoBar editModeActive={editModeActive} customers={customers} editHistory={editHistory} handleActionModal={handleDeleteModal} data={data} handleChange={invoiceReportOnChange} departments={departments} department={department}/>
           {logs !== undefined && logs.length > 0 &&
           <Accordion open title={i18n.t("invoiceReportList.invoiceReportModal.logs").toString()} titleStyle={{fontSize: "1.1rem", margin: 0}} style={{padding: "0px 10px 0px"}} contentStyle={{paddingLeft: 4}}>
            <div style={{maxHeight: "48vh",marginBottom:'10px'}}>
            <Datalist
                items={logs ?? []}
                uniqueKey="invoiceNumber"
                columns={logColumns}
                noItemsText={i18n.t("invoiceReportList.invoiceReportModal.table.empty")}
                initialSortKey="timeReported"
                descendingSort={false}
                setColumns={(cols) => /*this.setState({ logColumns: cols })*/console.log()}
              />
              </div>
              </Accordion>
           }
         <Accordion open={true} title={i18n.t("invoiceReportList.invoiceReportModal.invoices").toString()} titleStyle={{fontSize: "1.1rem", margin: 0}} style={{padding: "0px 10px 0px 10px"}}>   
             <>
             <span>
             {" "}
             <div style={{display:'flex',alignItems:'center'}}>
              <div style={{display:'flex',width:'200px',alignItems:'center'}}>
             <input
             id='searchField'
               placeholder={`Sök på fakturanummer`}
               type="text"
               onChange={(e) => {
                const newValue = e.target.value
                setInternalSearchString(newValue)
                search(newValue)
               }
              }
               style={{justifySelf:'flex-start'}}
               value={internalSearchString}
             />
             {searchCache.searchString.length > 0 && 
              <span onClick={() => {
                search('')
                setInternalSearchString('')
                }} style={{position:'relative',right:'18px',cursor:'pointer'}}><FontAwesomeIcon icon={'xmark'} /></span>
             }
             
             </div>
             <FontAwesomeIcon
               style={{ paddingLeft: "5px" }}
               icon="magnifying-glass"
             />
             <i style={{ paddingLeft: "5px" }}>
               {" "}
               { searchLoading ? <div className="loader"/>:searchCache.active && searchCache.searchResult.rowsFound> 0
                 ? `${searchCache.searchResult.rowsFound} ${searchCache.searchResult.rowsFound > 1 ? 'träffar':'träff'}`
                 : (searchCache.active && searchCache.searchResult.rowsFound == 0 ? i18n.t('dashboard.noHits'):'')}
             </i>
             </div>
           </span>
          
             <EditInvoiceReportTable departments={departments} movedItems={movedItems} customers={customers} contract={contract} copyRow={copyRow} handleDeleteModal={handleDeleteModal} deleteModal={deleteModal} deleteRow={deleteRow} addRow={addRow} reportType={reportType} invoiceKey={ reportType === 'Invoicereport' || reportType === 'Projectreport' 
    ? 'invoices' 
    : reportType === 'InvoicereportWithCSRD' || reportType === 'ProjectreportWithCSRD' 
      ? 'csrdGroup' 
      : 'invoices'} data={{...data}} callBack={callBack} reportedPeriods={reportedPeriods}/>
             </>
         </Accordion>  
         <div style={{display:'flex',flexDirection:'row-reverse'}}>
         <Button
                style={{width:'fit-content',color:'#173C53 '}}
                disabled={ !IsUserSinfra()}
                className="button button-submit"
                onClick={() => handleDeleteModal(noRowsLeft ? 'SUBMITBUTDELETEREPORTOPTION':'SUBMIT',true,-1)}
              >
                {submitActive ? (
                  <Spinner animation="border" size={"sm"} />
                ) : (
                  <>
                    <FontAwesomeIcon
                      icon={faPaperPlane}
                      style={{ marginRight: 4 }}
                    />
                    {t("general.send")}
                  </>
                )}
              </Button>
              </div>
         </>
    )
  
  }
